var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"welcome"},[_c('CustomerImportWelcome',{attrs:{"loading":_vm.loading,"numberOfCustomers":_vm.customerImportFormData.numberOfCustomers,"modal":true},on:{"skip":_vm.handleSkipForNow,"submit":_vm.handleGetStarted}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }